const HOMEPAGE_QUERY_PATHS = new Set(
  ['search', 'search/recommendations', 'events/saved-event-ids', 'v3/promoted/events', 'v3/destination/city-browse']
    .flatMap(suffix => [`/home/api/${suffix}`, `/api/home/${suffix}`]),
);

export function isReleaseCompatibleHomepagePost(method: string, pathname: string): boolean {
  return method === 'POST' && HOMEPAGE_QUERY_PATHS.has(pathname.endsWith('/') ? pathname.slice(0, -1) : pathname);
}
